export enum DevicePermissions {
  Unknown = 'unknown',
  Denied = 'denied',
  Prompt = 'prompt',
  Granted = 'granted',
  SystemDenied = 'systemDenied',
}
